import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ClientInformationAttribute } from 'src/app/models/client-information/ClientInformationAttribute'
import { ClientDto } from 'src/app/models/client/client-dto'
import { Indicator } from 'src/app/models/common/indicators'
import { FeatureStatusRecord } from 'src/app/models/features/feature-status-record'
import { TranslateService } from '@ngx-translate/core'

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(
    public router: Router,
    private translateService: TranslateService,
  ) {}

  clientHasAccessToFlip(client: ClientDto): boolean {
    return client.flipTemplateId != null && client.flipTemplateId !== ''
  }

  clientHasAccessToReddi(client: ClientDto): boolean {
    return true
  }

  clientHasAccessToSlat(client: ClientDto): boolean {
    const slatTool = client.tools.find(
      (tool: any) =>
        tool.toolName === 'Standard Language Assessment Tool Tracker - CELF P3',
    )
    return slatTool !== undefined
  }

  returnReviewIndicator(client: ClientDto): number {
    const reviews = client.indicators?.find(
      (indicator: Indicator) => indicator.reviews,
    )
    return reviews?.reviews ? Number(reviews.reviews) : 0
  }

  navigateTo(target: string, clientId: string, id?: string): void {
    const navigationRoutes: any = {
      dashboard: `/client-dashboard/${clientId}`,
      newFlip: `/flip-assessment/${clientId}`,
      newReddi: `/reddi/assessment/${clientId}`,
      newSlat: `/slat/assessment/${clientId}`,
      editSlat: `/slat/assessment/${clientId}/${id}`,
      historyFlip: `/flip/history/${clientId}`,
      historyReddi: `/reddi/history/${clientId}`,
      historySlat: `/slat/history/${clientId}`,
      reportFlip: `/flip/flip-report-form/${clientId}`,
      reportReddi: `/reddi/reddi-report-form/${clientId}`,
      reportSlat: `/slat/slat-report-form/${clientId}`,
      fullViewFlip: `/flip/graph/${clientId}`,
      reviews: `/client-reviews/${clientId}`,
    }
    this.router.navigate([navigationRoutes[target]])
  }

  createAttribute(
    display: string,
    value: string = '',
    placeholder: string = '',
  ): ClientInformationAttribute {
    return {
      display: display,
      value: value,
      placeholder: placeholder,
    }
  }

  getAttribute(
    attributes: ClientInformationAttribute[],
    display: string,
  ): ClientInformationAttribute {
    return attributes.find((attribute) => attribute.display === display)
  }

  setAttribute(
    attributes: ClientInformationAttribute[],
    display: string,
    value: string,
  ) {
    this.getAttribute(attributes, display).value = value
  }

  createEmptyAttributeList(): ClientInformationAttribute[] {
    return [
      this.createAttribute('Age', '', ''),
      this.createAttribute('DOB', '', ''),
      this.createAttribute('Gender', '', ''),
      this.createAttribute('Case Manager', '', ''),
    ]
  }

  getFeatureValue(features: FeatureStatusRecord[], featureName: string) {
    if (
      features.find((feature) => feature.name === featureName).enabled == null
    ) {
      return false
    } else {
      return features.find((feature) => feature.name === featureName).enabled
    }
  }

  isValidUUID(value: string): boolean {
    if (typeof value !== 'string') return false

    const relaxedUUIDRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

    return relaxedUUIDRegex.test(value)
  }

  public translateSafe(key: string | null | undefined): string {
    if (
      key === null ||
      key === undefined ||
      key === '' ||
      key === 'null' ||
      key === 'undefined'
    ) {
      return ''
    }

    const value = this.translateService.instant(key)
    return !value || value === key ? key : value
  }

  public getRefreshTimeOut(): number {
    return 5000
  }

  public getRefreshLapse(): number {
    return 60000
  }

  public getThrottleTimeOut(): number {
    return 10000
  }
}
